import { Dropdown } from 'primereact/dropdown';
import { type Control, Controller, type FieldPath } from 'react-hook-form';

import { useSites } from '@/services/sites';

import { useBulkDonorSchedulingStore } from '../hooks/use-bulk-donor-scheduling-store';

export function AspirationDropdown<
  Fields extends { aspirationSiteId: string },
>({
  className,
  control,
  disabled,
  valueChanged,
}: {
  className?: string;
  control: Control<Fields>;
  disabled?: boolean;
  valueChanged: () => void;
}) {
  const { data: sites, isLoading } = useSites({ filter: 'aspiration' });
  const [state] = useBulkDonorSchedulingStore();

  return (
    <Controller
      control={control}
      name={'aspirationSiteId' as FieldPath<Fields>}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { error },
      }) => {
        const message = state.messages?.[name];
        const sheetError = state.errors?.[name];
        return (
          <div>
            <Dropdown
              className={className}
              name={name}
              inputRef={ref}
              onBlur={onBlur}
              appendTo="self"
              options={sites ?? undefined}
              optionValue="id"
              optionLabel="name"
              filter
              filterPlaceholder="Search..."
              virtualScrollerOptions={{ itemSize: 40 }}
              filterInputAutoFocus={true}
              loading={isLoading}
              showClear
              value={value}
              onChange={(e) => {
                onChange(e.value);
                valueChanged();
              }}
              placeholder="Aspiration Site"
              disabled={disabled}
              invalid={!!error?.message || !!sheetError}
            />

            {error?.message || sheetError ? (
              <p className="mt-2 mb-0 text-red-500">
                {error?.message ?? sheetError}
              </p>
            ) : null}
            {message ? (
              <p className="mt-2 mb-0 text-emerald-500">{message.message}</p>
            ) : null}
          </div>
        );
      }}
    />
  );
}
